"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowAssetBodyToJSON = exports.ShowAssetBodyFromJSONTyped = exports.ShowAssetBodyFromJSON = void 0;
function ShowAssetBodyFromJSON(json) {
    return ShowAssetBodyFromJSONTyped(json, false);
}
exports.ShowAssetBodyFromJSON = ShowAssetBodyFromJSON;
function ShowAssetBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetID': json['assetID'],
    };
}
exports.ShowAssetBodyFromJSONTyped = ShowAssetBodyFromJSONTyped;
function ShowAssetBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'assetID': value.assetID,
    };
}
exports.ShowAssetBodyToJSON = ShowAssetBodyToJSON;
